"use memo"

import {
  AgxDivider,
  AgxSpacer,
  AgxToggleSwitch,
  AgxTypography,
} from '@urbanx/agx.ui-components2'
import { ComplianceData, ComplianceKey } from './contractCompliance'

type ComplianceItem = {
  key: string
  label: string
}

interface ContractComplianceStepProps {
  required: ComplianceItem[]
  optional: ComplianceItem[]
  complianceData: ComplianceData
  disabled?: boolean
  onToggle: (key: ComplianceKey, checked: boolean) => void
}

const ContractComplianceStep = ({
  required,
  optional,
  complianceData,
  disabled = false,
  onToggle,
}: ContractComplianceStepProps) => (
  <AgxSpacer direction="vertical" gap="spacing-3xl" fill>
    <AgxSpacer direction="vertical" gap="spacing-2xl" fill>
      <AgxTypography
          type="body_ui_strong"
          size="small"
          id="requiredDraft"
          color="var(--text-tertiary)"
        >
          Required to mark as Draft
        </AgxTypography>
      {required.map((item) => (
        <AgxSpacer
          key={item.key}
          direction="horizontal"
          gap="spacing-lg"
          fill
          contentAlignment="start"
          contentJustification="space-between"
          data-testid={`toggle-${item.key}`}
        >
          <AgxTypography type="body_ui" size="medium" id={item.key}>
            {item.label}
          </AgxTypography>
          <AgxToggleSwitch
            id={`toggle-${item.key}`}
            checked={complianceData[item.key as ComplianceKey] === true}
            disabled={disabled}
            onChange={(checked) => onToggle(item.key as ComplianceKey, checked)}
          />
        </AgxSpacer>
      ))}
    </AgxSpacer>
    <AgxDivider variant="horizontal" />
    <AgxSpacer direction="vertical" gap="spacing-2xl" fill>
      <AgxSpacer direction="vertical" gap="spacing-lg" fill>
        <AgxTypography
          type="body_ui_strong"
          size="small"
          id="requiredCompliance"
          color="var(--text-tertiary)"
        >
          Required to mark as Final
        </AgxTypography>
        {optional.map((item) => (
          <AgxSpacer
            key={item.key}
            direction="horizontal"
            gap="spacing-lg"
            fill
            contentAlignment="start"
            contentJustification="space-between"
            data-testid={`toggle-${item.key}`}
          >
            <AgxTypography type="body_ui" size="medium" id={item.key}>
              {item.label}
            </AgxTypography>
            <AgxToggleSwitch
              id={`toggle-${item.key}`}
              checked={complianceData[item.key as ComplianceKey] === true}
              disabled={disabled}
              onChange={(checked) =>
                onToggle(item.key as ComplianceKey, checked)
              }
            />
          </AgxSpacer>
        ))}
      </AgxSpacer>
    </AgxSpacer>
  </AgxSpacer>
)

export default ContractComplianceStep
